import { combineReducers } from "@reduxjs/toolkit";
import attributeValueSlice from "./slices/attributeValueSlice";

export default combineReducers({
  attributeValue: attributeValueSlice,
});
